let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7igsj")).then(() => parcelRequire('a8nB2'));